document.addEventListener('DOMContentLoaded', function() {
    window.setupProductPageSlider();

  if( document.querySelectorAll(".mobile-nav-category--list").length > 0){
    const targetNode = document.querySelector("store-header.header");
    if(window.innerWidth < 768){
      const fillNav = () => {
        if(!targetNode.classList.contains('is-filled')) targetNode.classList.add('is-filled');
      }
      fillNav();
      const observer = new MutationObserver(fillNav);
      observer.observe(targetNode, { attributes: true, childList: false, subtree: false });

      if(document.querySelector('.mobile-nav-category--list li .active')){
        var offsetValue = document.querySelector('.mobile-nav-category--list li .active').offsetLeft;
        var halfWidth = window.innerWidth/2 - 40;
        document.querySelector('.mobile-nav-category--list').scrollLeft = offsetValue - halfWidth;
      }

    }

    window.addEventListener('resize', function(event) {
      const targetNode = document.querySelector("store-header.header");
      const fillNav = () => {
        if(!targetNode.classList.contains('is-filled')) targetNode.classList.add('is-filled');
      }
      fillNav();
      const observer = new MutationObserver(fillNav);
      observer.observe(targetNode, { attributes: true, childList: false, subtree: false });
    })
      
  }

  // a/b test script
  var intervalId;
  function checkAndAddInput() {
    var bundleQtyElements = document.querySelector('.product_bundle-selector');
    var qtySelector = document.querySelector('.product-info__quantity-selector');
    
      if ( (getComputedStyle(bundleQtyElements).display === 'block' || bundleQtyElements.style.display === 'block' ) || ( getComputedStyle(qtySelector).display === 'block' || qtySelector.style.display === 'block' ) ) {
        var hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[_bundle_enable]';
        hiddenInput.value = 'true';
        
        document.querySelector('.product-info__buy-buttons .shopify-product-form').appendChild(hiddenInput);
  
        if (getComputedStyle(qtySelector).display === 'block' || qtySelector.style.display === 'block'){
         qtySelector.classList.add('quantity-enable');
        }
        
        clearInterval(intervalId);
      }
    
  }
  if(document.querySelectorAll('.product_bundle-selector').length > 0 || document.querySelectorAll('.product-info__quantity-selector').length > 0){
    intervalId = setInterval(checkAndAddInput, 1000);
  } 

  if(document.querySelectorAll('.bundle-selector-list').length > 0){
    document.querySelectorAll('.bundle-selector-list input[type="radio"]').forEach((input) => {
      var qty_value = input.getAttribute('data-qty');
      if (input.checked) {
         document.querySelector('.bundle-selector-label span').innerText = input.value;
         if( document.querySelectorAll('.quantity-selector__input').length > 0 ){
           document.querySelector('.quantity-selector__input').value = qty_value;
         }
      }
    
      input.addEventListener('change', () => {
        document.querySelector('.bundle-selector-label span').innerText = input.value;
        if( document.querySelectorAll('.quantity-selector__input').length > 0 ){
           document.querySelector('.quantity-selector__input').value = qty_value;
        }
      });
    });
  }

  function handleResize() {
    if(document.querySelectorAll('.size-variant-scrollbar').length > 0) {
        var sizeVariantPicker = document.querySelector(".size-variant-scrollbar");
        var actualWidth = document.querySelector('.variant-picker__option-info').offsetWidth;
        if (actualWidth) {
          sizeVariantPicker.style.width = actualWidth + "px";
        }   
    }
  }

  handleResize();
  
  window.addEventListener('resize', handleResize);

  // document.querySelectorAll(".product-card__swatch-list").forEach(el => {
  //   el.querySelector("input").click();
  // })

  window.appendTitleAndPrice = function() {
    // Select the elements to be cloned
    if(document.querySelector('.product-title-price')){
      const shorttitleElement = document.querySelector('.product__info--collection');
      const titleElement = document.querySelector('.product-info__title');
      const ratingElement = document.querySelector('.oke-product-star-rating');
      const priceElement = document.querySelector('.product-info__price');
    
      // Select the target container
      const targetContainer = document.querySelector('.product-title-price');
    
      // Check if the elements already exist in the target container
      
      const existingShorttitle = targetContainer.querySelector('.product__info--collection');
      const existingTitle = targetContainer.querySelector('.product-info__title');
      const existingPrice = targetContainer.querySelector('.product-info__price');
    
      if (existingTitle && existingPrice) {
          // If they exist, update their innerHTML
          existingShorttitle.innerHTML = shorttitleElement.innerHTML;
          existingTitle.innerHTML = titleElement.innerHTML;
          existingPrice.innerHTML = priceElement.innerHTML;
      } else {
          // If they don't exist, clone and append them
          if(document.querySelectorAll('.product__info--collection').length > 0){
            const clonedShorttitle = shorttitleElement.cloneNode(true);  
            targetContainer.appendChild(clonedShorttitle);
          }
          
          const clonedTitle = titleElement.cloneNode(true);
const clonedPrice = priceElement.cloneNode(true);
// Rebuild mobile sale pricing layout
const mobilePriceList = clonedPrice.querySelector('.price-list');
const mobileBadgeList = clonedPrice.querySelector('.product-info__badge-list');

if (mobilePriceList && mobileBadgeList) {
  const mobilePriceGroup = document.createElement('div');
  mobilePriceGroup.className = 'sw-mobile-price-group';

  mobilePriceList.parentNode.insertBefore(mobilePriceGroup, mobilePriceList);

  mobilePriceGroup.appendChild(mobilePriceList);
  mobilePriceGroup.appendChild(mobileBadgeList);
}
/* Create compact title + price row */
const titlePriceRow = document.createElement('div');
titlePriceRow.classList.add('sw-title-price-row');

const titleSide = document.createElement('div');
titleSide.classList.add('sw-title-side');

const priceSide = document.createElement('div');
priceSide.classList.add('sw-price-side');

/* Title goes left */
titleSide.appendChild(clonedTitle);

/* Detect whether product has reviews */
const reviewCountElement = ratingElement
  ? ratingElement.querySelector('.oke-product-star-rating-count')
  : null;

const reviewCount = reviewCountElement
  ? parseInt(reviewCountElement.textContent.replace(/\D/g, ''), 10) || 0
  : 0;

/* Zero reviews = show NEW badge */
if (reviewCount === 0) {
  const newBadge = document.createElement('span');
  newBadge.className = 'sw-new-product-badge';
  newBadge.textContent = 'NEW';

  clonedTitle.appendChild(newBadge);
}

/* Reviews go directly under title */
if (ratingElement && reviewCount > 0) {
  const clonedRating = ratingElement.cloneNode(true);
  titleSide.appendChild(clonedRating);
}

/* Price goes right */
priceSide.appendChild(clonedPrice);

titlePriceRow.appendChild(titleSide);
titlePriceRow.appendChild(priceSide);

targetContainer.appendChild(titlePriceRow);
      }
    }
  };

  // Call the function
  window.appendTitleAndPrice();

/* ========================================
   MOBILE STICKY REVIEW BAR
   ======================================== */

function updateStickyReviewBar() {
  if (window.innerWidth > 767) return;

  const reviewTrigger =
    document.querySelector(
      '.product-title-price .sw-title-side .oke-product-star-rating'
    ) ||
    document.querySelector(
      '.product-title-price'
    );

  const stickyReviewBar = document.querySelector(
    '.product-mobile-reviews'
  );

  if (!reviewTrigger || !stickyReviewBar) return;

  const triggerPosition = reviewTrigger.getBoundingClientRect();

  /* Show once original reviews disappear behind header */
  const stickyHeaderHeight = 100;

  if (triggerPosition.bottom <= stickyHeaderHeight) {
    stickyReviewBar.classList.add('sw-sticky-review-visible');
  } else {
    stickyReviewBar.classList.remove('sw-sticky-review-visible');
  }
}

/* Update whenever user scrolls */
window.addEventListener('scroll', updateStickyReviewBar, {
  passive: true
});

/* Check position on normal page load */
setTimeout(function () {
  updateStickyReviewBar();
}, 500);

/* Re-check position when Safari restores page with Back/Forward */
window.addEventListener('pageshow', function() {
  setTimeout(function () {
    updateStickyReviewBar();
  }, 200);
});
  //window.collectionFilter(); 
  

  
});

window.collectionFilter = function () {
  const sortBy = () => {
    waitElement('#accordion-sort-by .accordion__toggle', tSec => {
      const isClosed = document.querySelector("#accordion-sort-by").getAttribute('aria-expanded');
      setTimeout(() => {
        if (isClosed === 'false') tSec.click();
      }, 100);
    });
  };
  sortBy();
  
  waitElement('facet-floating-filter button', () => {
    if(!document.querySelector(".mobile-filter-toggle").classList.contains("event-added")){
      document.querySelector(".mobile-filter-toggle").classList.add("event-added");
      document.querySelector(".mobile-filter-toggle").addEventListener('click', e => {
        document.querySelector("facet-floating-filter button").click();
        waitElement('facet-drawer', tSec => {
          sortBy();
          if (e.target.innerText.trim() === 'Sort') tSec.classList.add('sort_open');
          else tSec.classList.remove('sort_open');
        });
      });
    }
  });
  
  function waitElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    } else {
      setTimeout(() => waitElement(selector, callback), 100);
    }
  }
}

window.setupProductPageSlider = function () {
  window.collectionFilter();
  if(window.location.href.includes("/collections")){
    // collection page slider with a/b test element

      function minHeight(parentElement, childElement) {
      let productGrids = document.querySelectorAll(parentElement),
          gridPositions = [],
          positionGrids = [];
      if(productGrids.length == 0) return;
      
      productGrids.forEach(function(grid) {
        if(gridPositions.indexOf(grid.offsetTop) == -1) gridPositions.push(grid.offsetTop);
      });
      
      gridPositions.forEach(function (position) {
        let grids = Array.from(productGrids).filter(function (grid) {
          return (grid.offsetTop == position)
        });
        positionGrids.push(grids);
      });
  
      positionGrids.forEach((grids,index) => {
        let heights = []
        grids.forEach(function (grid) {
          let tmp = [];
          grid.querySelectorAll(childElement).forEach(function(element) {
            element.style.removeProperty('min-height');
            if(window.innerWidth >= 768){
              tmp.push(element.offsetHeight);
            }else{
              tmp.push(element.offsetHeight);
            }
            
          });
          heights.push(tmp);
        });
        if(heights.length > 0){
          let totalSelector = Math.max(...heights.map(ele => {
            return ele.length;
          }));
          grids.forEach(function (grid) {
            for (let index = 0; index < totalSelector; index++) {
              let elementHeights = Math.max(...heights.map(ele => {
                return ele[index];
              }));
              grid.querySelectorAll(childElement)[index].style.minHeight = `${elementHeights}px`;
            }
          });
        }
      });  
    }

    window.addEventListener('resize', function() {
      minHeight('.product-cart__images--slider .slide-item', '.product-cart__images--slider .slide-item img');
    });
    
      
    $('.product-cart__images--slider').slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });

    $('.product-cart__images--slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      const nextSlideDiv = slick.$slides.eq(nextSlide);
      const nextSlideImage = nextSlideDiv.find('img');
      const nextSlideImageUrl = nextSlideImage.attr('data-src');
      nextSlideImage.attr('src', nextSlideImageUrl);
      minHeight('.product-cart__images--slider .slide-item', '.product-cart__images--slider .slide-item img');
    });

    function observeSliderImages(){
      function handleIntersection(entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target;
            if(element.querySelector(".A-B-images img")){
              element.querySelector(".A-B-images img").src = element.querySelector(".A-B-images a.slide-item.slick-active img").dataset.src;
              observer.unobserve(element);
            }
          }
        });
      }
      const observer = new IntersectionObserver(handleIntersection, { root: null, threshold: 0.1 });
      const elements = document.querySelectorAll("product-list product-card")
      elements.forEach(element => {
        observer.observe(element);
      });
    }

    var intervalElement;
    function checkImages() {
      var imagesElement = document.querySelector('.product-cart__images');
      if ( (getComputedStyle(imagesElement).display === 'block' || imagesElement.style.display === 'block' ) ) {
        observeSliderImages();
        document.querySelectorAll('.product-cart__images').forEach(function(elm) {
          elm.classList.add('active');
        });
        document.querySelector("product-list").classList.add("variant-disabled");
        // document.querySelectorAll('.product-card__swatch-list input').forEach(function(input) {
        //   if($(input).is(':checked')){
        //     var productCard = $(input).parents('.product-card');
        //     var filteringElement = productCard.find('.product-cart__images--slider'); 
        //     var currentValue = 'color-'+input.dataset.value;
        //     var target = currentValue.toLowerCase();
        //     filteringElement.slick('slickUnfilter');
        //     filteringElement.slick('slickFilter', `.${target}`);
        //     minHeight('.product-cart__images--slider .slide-item', '.product-cart__images--slider .slide-item img');
        //     input.closest("product-card").querySelector('.A-B-images a.slide-item.slick-active img').src = input.closest("product-card").querySelector('.A-B-images a.slide-item.slick-active img').dataset.src;
        //   }
        // })

        document.querySelectorAll("product-card").forEach(el => { 
          el.querySelectorAll("fieldset input").forEach(ele => {
            if(ele.closest("product-card").querySelector(".A-B-images a.slide-item.color-" + ele.dataset.value + " img")){
              ele.closest("product-card").querySelector(".A-B-images a.slide-item.color-" + ele.dataset.value + " img").src = ele.closest("product-card").querySelector(".A-B-images a.slide-item.color-" + ele.dataset.value + " img").dataset.src;
            }
          })
        })
        clearInterval(intervalElement);
      }
    }

    if(document.querySelectorAll('.product-cart__images').length > 0){
      intervalElement = setInterval(checkImages, 100);
    }

   const facetform = document.querySelector('#facet-form');

   // facetform.addEventListener('change', function() {
   //    console.log('yess');
   // })
    
    // document.querySelectorAll('.product-card__swatch-list input').forEach(function(input) {
    //   var swatch_value = 'color-'+input.value;
    //   input.addEventListener('change', function(elm){
    //     var productCard = $(this).parents('.product-card');
    //     if($(".A-B-images.active").length > 0){
    //       var filteringElement = productCard.find('.product-cart__images--slider');
    //       var currentValue = 'color-'+input.dataset.value;
    //       var target = currentValue.toLowerCase();
    //       filteringElement.slick('slickUnfilter');
    //       filteringElement.slick('slickFilter', `.${target}`);
    //       filteringElement.slick('slickGoTo', 0);
    //       minHeight('.product-cart__images--slider .slide-item', '.product-cart__images--slider .slide-item img');
    //       elm.currentTarget.closest("product-card").querySelector('.A-B-images a.slide-item.slick-active img').src = elm.currentTarget.closest("product-card").querySelector('.A-B-images a.slide-item.slick-active img').dataset.src;         
    //     }
    //   }); 
    // });
  }
}

var intervalShipaid;
function shipaidBlock() {
  var shipaidElement = document.querySelector('.shipaid-widget-box');
  if ( (getComputedStyle(shipaidElement).display === 'block' || shipaidElement.style.display === 'block' ) ) {
    document.querySelector('body').classList.add('shipaid-hidden');
    clearInterval(intervalShipaid);
  }
}

if(document.querySelectorAll('.shipaid-widget-box').length > 0){
    intervalShipaid = setInterval(shipaidBlock, 100);
}

var reviewInterval;
var yotpoWidget = 100;

function reviewsList(){
  if(document.querySelectorAll('.yotpo-sr-bottom-line-summary').length > 0 ) {
    //let rate =  document.querySelector('.yotpo-sr-bottom-line-summary .sr-only').innerText.replaceAll(' out of 5 star rating', '');
    //console.log('rate', rate);
    let rate =  document.querySelector('.yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-left-panel').innerText;
    let rateN = parseInt(rate);
    var  mobileReviewElm = document.querySelector('.product-mobile-reviews'); 
    document.querySelector(".product-mobile-reviews").insertAdjacentHTML('afterbegin',`<div class="r-srb-rate">${rate}</div>`);

    
    if ( document.querySelectorAll(".product-mobile-reviews .yotpo-stars").length == 0 ){
      setTimeout(function(){
        let ratingHtml = document.querySelector('.product-info .yotpo-bottom-line-scroll-panel').innerHTML;
        document.querySelector(".product-mobile-reviews .yotpo.bottomLine").insertAdjacentHTML('afterbegin',ratingHtml);
        document.querySelectorAll(".product-mobile-reviews linearGradient").forEach(function(item){
          item.querySelector("stop:last-child").setAttribute('stop-color','transparent');
          item.querySelector("stop:first-child").setAttribute('stop-color','#925951');
        })
      },100)
      
    }
    
    if( rateN <= 0 ) {
      setTimeout(function(){
        mobileReviewElm.classList.remove('active');
      },100)  
      mobileReviewElm.classList.add('no-review');
    }else {
      setTimeout(function(){
        mobileReviewElm.classList.add('active');
      },100)
      mobileReviewElm.classList.remove('no-review');
    }
    
    clearInterval(reviewInterval);
  }
}

if(document.querySelectorAll('.product-mobile-reviews').length > 0 && window.innerWidth <= 768){
 
 document.querySelectorAll('.product-mobile-reviews').forEach(function(element) {
    element.addEventListener('click', function() {
         var yotpoWidgetElement = document.querySelector('.shopify-section--apps');
         var yotpoWidget = yotpoWidgetElement.offsetTop - 100;      
         window.scrollTo({
              top: yotpoWidget,
              behavior: 'smooth'
          });
    });
});

reviewInterval = setInterval(reviewsList, 100);
}


var shipaidPopup = setInterval(function(){
   
  if(document.querySelectorAll("shipaid-popup-learn-more").length > 0) {
   
    setTimeout(function() {
      document.querySelector("shipaid-popup-learn-more").shadowRoot.querySelector(".shipaid-popup").style.padding = "20px 10px";
      document.querySelector("shipaid-popup-learn-more").shadowRoot.querySelector(".shipaid-popup").querySelector('.popup-title').style.fontSize = "20px";
      document.querySelector("shipaid-popup-learn-more").shadowRoot.querySelector(".shipaid-popup").querySelector(".popup-logo svg").style.maxWidth = "100%";
      document.querySelector("shipaid-popup-learn-more").shadowRoot.querySelector(".shipaid-popup").querySelector(".popup-logo svg").style.height = "auto";
      document.querySelector("shipaid-popup-learn-more").shadowRoot.querySelector(".shipaid-popup").querySelectorAll(".popup-disclaimer-subtitle").forEach(function(item){
          item.querySelector('div').style.marginLeft= "0px";
          item.querySelector('div').style.width= "60px";
          item.querySelector('div').style.minWidth= "60px";
          item.querySelector('svg').style.maxWidth = "50px";
          //item.querySelector('.popup-icon-b').style.marginLeft= "0px";
      });
    },500);
    clearInterval(shipaidPopup)
  }

},1000)
